import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// constellation
import { Anchor, Text } from '@zillow/constellation';

// actions
import { updateSubscription } from 'app/shared/flux/actions/MarketingActions';

// misc/utils
import { augmentError, formatForLog } from 'app/shared/utils/errors';
import { queryStringToQueryObject } from 'app/shared/utils/urlUtils';
import * as S from './styles';

// types
import { CampaignType } from './CampaignType';
import type { State } from 'app/shared/types/State';
import type { MarketUpdateStatusErrorType, MarketUpdateStatusType } from 'app/shared/types/ApiResponseTypes';

const logger = log.child('pages/UnsubscribePage');

const UnsubscribePage = () => {
    const queryString = useSelector((state: State) => state.router.location.search);
    const pathname = useSelector((state: State) => state.router.location.pathname);
    const dispatch = useDispatch();
    const queryObj = queryStringToQueryObject(queryString);
    const { email, enabled, marketUpdateId } = queryObj;
    const parsedEnabled: boolean = enabled === 'true';
    const [isSubscribed, setIsSubscribed] = useState(parsedEnabled);
    const [address, setAddress] = useState('');
    const { campaign }: { campaign: keyof typeof CampaignType } = useParams();
    useEffect(() => {
        dispatch(updateSubscription({ email, enabled: isSubscribed, marketUpdateId }))
            // @ts-ignore
            .then((res: MarketUpdateStatusType) => {
                const { marketUpdateEnabled, streetAddress } = res;
                const { street, state, city, zip, unit, hasUnitLabel } = streetAddress;
                const formattedAddress: string = `${street} ${hasUnitLabel ? unit : ''}, ${city}, ${state} ${zip}`;
                setIsSubscribed(marketUpdateEnabled);
                setAddress(formattedAddress);
            })
            .catch((err: MarketUpdateStatusErrorType) => {
                augmentError(err, {
                    root: 'pages/UnsubscribePage#useEffect',
                    pathAttempted: pathname,
                    queryAttempted: queryString
                });
                logger.error(formatForLog(err), 'Unsubscribe page: Error updating subscription');
            });
    }, [isSubscribed]);
    const handleUndoClick = () => {
        setIsSubscribed(!isSubscribed);
    };
    return (
        <>
            <S.Container>
                <S.Content>
                    <Text fontType="h5" as="h1" marginBottom="sm">
                        You have been {isSubscribed ? 'subscribed to' : 'unsubscribed from'} the{' '}
                        {CampaignType[campaign]}.
                    </Text>
                    <Text fontType="body" as="p" marginBottom="sm">
                        Property: <S.Emphasize>{address}</S.Emphasize>
                    </Text>
                    <Text fontType="body" as="p" marginBottom="sm">
                        Email address: <S.Emphasize>{email}</S.Emphasize>
                    </Text>
                    <Text fontType="body">
                        <Anchor onClick={handleUndoClick}>
                            <S.Emphasize>Undo</S.Emphasize>
                        </Anchor>
                    </Text>
                </S.Content>
            </S.Container>
        </>
    );
};

export default UnsubscribePage;
